import { useNavigate } from "react-router-dom";
import { Button, Flex, Table } from "antd";
import { StringParam } from "use-query-params";
import _ from "lodash";

import {
  FIELD_ORDERS,
  FIELD_KEYS,
  FIELD_LABELS,
  TABLE_FIELDS,
} from "constants/ItemFields";
import { encodeQueryParamsWithProducts } from "functions/queryParamFuncs";
import { useProduct } from "hooks/useProduct";
import CollapsibleText from "components/Common/CollapsibleText";
import DateTime from "components/Common/DateTime";
import StatusTag from "components/Common/StatusTag";

const columnAdditionalConfig = {
  [FIELD_KEYS.PRODUCT]: {
    align: "left",
    width: "15rem",
  },
  [FIELD_KEYS.REF_NO]: {
    align: "left",
  },
  [FIELD_KEYS.START_DATE_TIME]: {
    width: "10rem",
  },
  [FIELD_KEYS.STATUS]: {
    width: "8rem",
  },
};

const ItemTable = ({ tableData, loading }) => {
  const navigate = useNavigate();
  const { selectedProductIds } = useProduct();

  const navigateToItemDetails = (itemUuid) => {
    return navigate({
      pathname: "/items/details",
      search: `?${encodeQueryParamsWithProducts(
        selectedProductIds,
        { itemUuid: StringParam },
        { item: itemUuid }
      )}`,
    });
  };

  const columns = _.intersection(FIELD_ORDERS, TABLE_FIELDS).map((field) => ({
    title: FIELD_LABELS[field],
    dataIndex: field,
    align: "center",
    render: (value, index, row) => renderField(field, value, index, row),
    ...(columnAdditionalConfig[field] ?? {}),
  }));

  const renderField = (field, val, row, index) => {
    switch (field) {
      case FIELD_KEYS.NO:
        return index + 1;
      case FIELD_KEYS.PRODUCT:
        return (
          <CollapsibleText
            content={val}
            width={columnAdditionalConfig[field]?.width}
          />
        );
      case FIELD_KEYS.REF_NO:
        return (
          <Flex>
            <Button
              onClick={() => navigateToItemDetails(row.uuid)}
              type="link"
              className="user-selectable"
              style={{ padding: 0 }}
            >
              {val}
            </Button>
          </Flex>
        );
      case FIELD_KEYS.STATUS:
        return <StatusTag status={val} />;
      case FIELD_KEYS.START_DATE_TIME:
        return <DateTime utcValue={val} />;
      case FIELD_KEYS.ACTION:
        return (
          <Button type="link" onClick={() => navigateToItemDetails(row.uuid)}>
            View
          </Button>
        );
      default:
        return val ?? "-";
    }
  };

  return (
    <>
      <Table
        columns={columns}
        dataSource={tableData}
        rowKey={(record) => record.uuid}
        loading={loading}
        pagination={false}
        size="middle"
      />
    </>
  );
};

export default ItemTable;
